const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:5001";

export const submitBugReport = async ({
  type,
  title,
  description,
  userEmail,
  userName,
  token,
}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/bug-reports`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        type,
        title,
        description,
        userEmail,
        userName,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to submit report");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting bug report:", error);
    throw error;
  }
};
